import { SubSalesOrder, FileElement, Equipment, BreakerPS, OrderType } from "./misc-classes";

export class TblHeadCellDef{
    constructor(private _cellHeadText:string,private _cellHeadCss:string,
                private _cellIndex:number, private _width:string,
                private _cellGroup:UITblGroup,
                private _aggregateType:AggregateType = AggregateType.None){

    }
    get cellHeadText():string{
        return this._cellHeadText;
    }
    get cellHeadCss():string{
        return this._cellHeadCss;
    }
    get cellIndex():number{
        return this._cellIndex;
    }
    get width():string{
        return this._width;
    } 
    get cellGroup():UITblGroup{
        return this._cellGroup;
    }
    get aggregateType():AggregateType{
        return this._aggregateType;
    }
}
export enum UITblGroup{
    Marketing = 1,
    ProjManagement = 2,
    SCM = 3,
    Engineering = 4,
    PurchasePO = 5,
    Planning = 6,
    PurchaseMatReceipt = 7,
    Store = 8,
    Production = 9,
    Quality = 10,
    Logistics = 11,
    Default = 0
} 
export enum AggregateType {
    None = 0,
    SUM = 1,
    MAX = 2,
    MIN = 3,
    COUNT =4,
    DISTINCT_COUNT = 5
}
export class UiTblSubSOBrkPSLevel {
	public soId:string;
	public plantName: string;
	public customerName: string;
	public projectName: string;
	public salesOrderNo: string;
	public salesOrderNoNew: string;
	public subSalesOrderNo: string;
	public rowHeader: string;
	
	public plannedManfMonth: string;
	public invoicingmonth: string;
	public plannedRevenueMonth: string;
	public manfStrategy: string;
	public plndLineLoadingDate: string;
	public reqLineLoadingDate: string;
	public rotddate: string;
	public actLineLoadingDate: string;
	public customerPoValue: string;
	public contractualValue: string;
	public marketingEngineer: string;
	public projectManager: string;
	public projectEngineer: string;
	public elecDesignEngineer: string;
	public mechDesignEngineer: string;
	public salesChannelName: string;
	public regionName: string;
	public poDate: string;
	public clearPODate: string;
	public consultantName: string;
	public warrantyMonths: string;
	public specialPoint: string;
	public specialPointFiles: Array<FileElement> = [];

	public ordertypeName: string;
	public splPriceFileTokens : Array<FileElement> = [];
	public contractDeliveryFirm: string;
	public contractDeliveryWeeks: string;
	public contractDeliveryDate: string;
	public ldApplicability: string;
	public ldPercentage: string;
	public ldCap: string;
	public deliveryTerm: string;
	public placeOfDelivery: string;
	public daysgoodsReach : string;
	public boardname : string;
	public delayreason:string;
	public deliveryFromAbb: string;
	public paymentTerm: string;
	public paymentDays: string;
	public FCMMatCost: string;
	public JSRMatCost: string;
	public FCMGM: string;
	public JSRGM: string;
	public FCMNM: string;
	public JSRNM: string;
	public AdvPmtCondition: string;
	public AdvPmt: string;
	public AdvPmtMilestone: string;
	public PBGPayCondition: string;
	public CPBGPayCondition: string;
	public SOCreationPlanned: string;
	public SOCreationActual: string;
	public SOCreationRemarks: string;
	public SOReleasePlanned: string;
	public SOReleaseActual: string;
	public SOReleaseRemarks: string;
	public OrderHandOverPlanned: string;
	public OrderHandOverActual: string;
	public OrderHandOverRemarks: string;
	public ABGACGSubmissionDetails: string
	public ABGACGSubmissionPlannedDate: string
	public abgOrAcgPlndCollDate : string
	public ABGACGActSubmissDate: string;
	public ABGACGActCollectDate: string;
	public PBGSubmissionDetails: string;
	public pbgReqSubDate: string;
	public pbgPlndSubDate: string
	public PBGActSubmissDate: string;
	public PBGActCollectDate: string;
	public CPBGSubmissionDetails: string;
	public CPBGActSubmissDate: string;
	public CPBGActCollectDate: string;
	public variantOfProduct: string;
	public noOfPanels: string;
	public complexityOfJobs: string;
	public noOfFeedertypes: string;
	public plannedSLDSubmissDate: string;
	public initialSLDSubmissActualDate: string;
	public remarkForSLDSubmission: string;
	public plannedGAFDrawSubmissDate: string;
	public actualGAFDrawSubmissDate: string;
	public remarkForGAFSubmissActualDate: string;

	public plannedSchBOMSubmissDate: string;
	public actualSchBOMSubmisDate: string;
	public remarkSchBOMSubmissDate: string;
	public plannedBusBarSizingCalcSubmissDate: string;
	public actualBusBarSizingCalcSubmissDate: string;
	public remarkBusBarSizingCalcSubmissDate: string;
	public finalDrawingSubmissDate: string;
	public insulationLevelKV: string;
	public typeOfEquipment: string;
	public typeOfBreaker: string;
	public qtyOfPanel: string;
	public totalqtyOfBreaker: string;
	public qtyOfBreaker: string

	public breakerPS: string;
	public importedEarthingSwitchApplicability: string;

	public qtyOfVSC: string;
	public kioskApplic: string;
	public tempRiseTestApplic: string;
	public impBrkApplic: string;
	public impVSCApplic: string;
	public spareApplic: string;
	public etApplic: string;
	public geRelayApplic: string;

	public busbarMaterial: string;
	public busbarSleeve: string;
	public cmntOnActualSubmissDate: string;
	public cmntOnActualComplainceDate: string;
	public plannedDrawingAprvlDate: string;
	public actualDrawingAprvlDate: string;
	public remarkDrawingAprvlDate: string;
	public plannedCTFinalEnggToPMDate: string;
	public actualCtFinalEnggToPMDate: string;
	public remarkCtFinalEnggToPMDate: string;

	public plannedSpecialPriceGvnbyENGGtoPM : string
	public actualSpecialPriceGvnbyENGGtoPM : string
	public remarkSpecialPriceGvnbyENGGtoPM : string

	public plannedCTFinalPMtoSCMDate: string;
	public actualCTFinalPMtoSCMDate: string;
	public remarkCTFinalPMtoSCMDate: string;
	public plannedSpecialMatPricePmtoSCm: string
	public actualSpecialMatPricePmtoSCm: string
	public remarkSpecialMatPricePmtoSCm: string
	public plannedCTFinalfromSCMDate: string;
	public actualCTFinalfromSCMDate: string;
	public remarkCTFinalfromSCMDate: string;
	public plannedSpecialMatPricefromSCMDate: string;
	public actualSpecialMatPricefromSCMDate: string;
	public remarkSpecialMatPricefromSCMDate: string;

	public plannedPackingDispatchClrDate: string;
	public requestedPackingDispatchClrDate: string;
	public actualPackingDispatchClrDate: string;
	public remarkPackingDispatchClrDate: string;
	public plannedSLDApprovalDate: string;
	public actualSLDApprovalDate: string;
	public remarkSLDApprovalDate: string;
	public plannedC40Date: string;
	public actualC40Date: string;
	public remarkC40Date: string;
	public plannedC50Date: string;
	public actualC50Date: string;
	public remarkC50Date: string;
	public plannedC60Date: string;
	public actualC60Date: string;
	public remarkC60Date: string;
	public plannedLongLeadDate: string;
	public actualLongLeadDate: string;
	public remarkLongLeadDate: string;
	public plannedImpBrkrPORlsDate: string;
	public actualImpBrkrPORlsDate: string;
	public remarkImpBrkrPORlsDate: string;

	public plannedImpVscPORlsDate: string;
	public actualImpVscPORlsDate: string;
	public remarkImpVscPORlsDate: string;
	public plannedGERelayPORlsDate: string;
	public actualGERelayPORlsDate: string;
	public remarkGERelayPORlsDate: string;
	public plannedCTPTPORlsDate: string;
	public actualCTPTPORlsDate: string;
	public remarkCTPTPORlsDate: string;
	public plannedRelayPORlsDate: string;
	public actualRelayPORlsDate: string;
	public remarkRelayPORlsDate: string;
	public plannedBreakerPORlsDate: string;
	public actualBreakerPORlsDate: string;
	public remarkBreakerPORlsDate: string;
	public plannedSAPORlsDate: string;
	public actualSAPORlsDate: string;
	public remarkSAPORlsDate: string;
	public plannedMeteringBoxPORlsDate: string;
	public actualMeteringBoxPORlsDate: string;
	public remarkMeteringBoxPORlsDate: string;
	public plannedPickListtoStoresDate: string;
	public requestedPickListtoStoresDate: string;
	public actualPickListtoStoresDate: string;
	public remarkPickListtoStoresDate: string;

	public plannedImpBrkrRcptDate: string;
	public requestedImpBrkrRcptDate: string;
	public supplierImpBrkrRcptDate: string;
	public actualImpBrkrRcptDate: string;
	public remarkImpBrkrRcptDate: string;
	public plannedImpVSCRcptDate: string;
	public requestedImpVSCRcptDate: string;
	public supplierImpVSCRcptDate: string;
	public actualImpVSCRcptDate: string;
	public remarkImpVSCRcptDate: string;
	public plannedGERelayRcptDate: string;
	public requestedGERelayRcptDate: string;
	public supplierGERelayRcptDate: string;
	public actualGERelayRcptDate: string;
	public remarkGERelayRcptDate: string;
	public plannedCTPTRcptDate: string;
	public requestedCTPTRcptDate: string;
	public supplierCTPTRcptDate: string;
	public actualCTPTRcptDate: string;
	public remarkCTPTRcptDate: string;
	public plannedRelayRcptDate: string;
	public requestedRelayRcptDate: string;
	public supplierRelayRcptDate: string;
	public actualRelayRcptDate: string;
	public remarkRelayRcptDate: string;
	public plannedBreakerRcptDate: string;
	public requestedBreakerRcptDate: string;
	public supplierBreakerRcptDate: string;
	public actualBreakerRcptDate: string;
	public remarkBreakerRcptDate: string;
	public plannedJumperRcptDate: string;
	public requestedJumperRcptDate: string;
	public supplierJumperRcptDate: string;
	public actualJumperRcptDate: string;
	public remarkJumperRcptDate: string;
	public plannedMeterBoxRcptDate: string;
	public requestedMeterBoxRcptDate: string;
	public supplierMeterBoxRcptDate: string;
	public actualMeterBoxRcptDate: string;
	public remarkMeterBoxRcptDate: string;
	public plannedSARcptDate: string;
	public requestedSARcptDate: string;
	public supplierSARcptDate: string;
	public actualSARcptDate: string;
	public remarkSARcptDate: string;
	public plannedBoughtoutFabricationRcptDate: string;
	public requestedBoughtoutFabricationRcptDate: string;
	public supplierBoughtoutFabricationRcptDate: string;
	public actualBoughtoutFabricationRcptDate: string;
	public remarkBoughtoutFabricationRcptDate: string;

	public plannedInHouseFabricationRcptDate: string;
	public requestedInHouseFabricationRcptDate: string;
	public supplierInHouseFabricationRcptDate: string;
	public actualInHouseFabricationRcptDate: string;
	public remarkInHouseFabricationRcptDate: string;

	public plannedMatIssuetoLineDate: string;
	public requestedMatIssuetoLineDate: string;
	public actualMatIssuetoLineDate: string;
	public remarkMatIssuetoLineDate: string;
	public plannedLooseMatIssueDate: string;
	public looseMaterialIssueToDispatchRequestDate: string;
	public actualLooseMatIssueDate: string;
	public remarkLooseMatIssueDate: string;
	public plannedMechStickerDate: string;
	public requestedMechStickerDate: string;
	public actualMechStickerDate: string;
	public remarkMechStickerDate: string;
	public plannedMechElecTestDate: string;
	public requestedMechElecTestDate: string;
	public actualMechElecTestDate: string;
	public remarkMechElecTestDate: string;
	public plannedFATDate: string;
	public requestedFATDate: string;
	public actualFATDate: string;
	public remarkFATDate: string;
	public plannedGreenStickerDate: string;
	public requestedGreenStickerDate: string;
	public actualGreenStickerDate: string;
	public remarkGreenStickerDate: string;
	public plannedDispatchDate: string;
	public requestedDispatchDate: string;
	public actualDispatchDate: string;
	public remarkDispatchDate: string;
	public partialDispatchQty: string;
	public actualEarthlingTruckDispatchDate: string;
	public actualSparesDispatchDate: string;
	public serialNo: Array<string> = [];
	

	public totalBreakerPsCountForSo:number = 0;
	public totalBreakerPsCountForSubSo:number = 0;
	public totalBreakerPsCountForEquip:number = 0;
    // public totalEquipmentCount:number = 0;
	// public totalEquipmentCountForSubSo:number = 0;
	// public totalEquipmentCountForEquip:number = 0;
	

	public cellRowSpan:Array<number> = [];

	constructor(private _subSoActObj: SubSalesOrder, public equipment:Equipment, public breaker:BreakerPS, private _isFirstRowInSO:boolean, private _isFirstRowInSubOrder:boolean, private _isFirstRowInEquipment:boolean) {
		
	}

    get isFirstRowInSO():boolean{
        return this._isFirstRowInSO;
    }
    get isFirstRowInSubOrder():boolean{
        return this._isFirstRowInSubOrder;
	}
	get isFirstRowInEquipment():boolean{
        return this._isFirstRowInEquipment;
    }


	searchText(_srchText: string): boolean {
		_srchText = _srchText.toLowerCase();
		if (this.plantName && this.plantName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.customerName && this.customerName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.projectName && this.projectName.toLowerCase().indexOf(_srchText) >= 0) return true;
		
		if (this.salesOrderNo && (this.salesOrderNo + '').toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesOrderNoNew && (this.salesOrderNoNew + '').toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.subSalesOrderNo && this.subSalesOrderNo.toLowerCase().indexOf(_srchText) >= 0) return true;

		// if (this.manfStrategy && this.manfStrategy.toLowerCase().indexOf(_srchText) >= 0) return true;
		//if(this.customerPoValue && this.customerPoValue.toLowerCase().indexOf(_srchText) >= 0) return true;
		//if(this.contractualValue && this.contractualValue.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.marketingEngineer && this.marketingEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.projectManager && this.projectManager.toLowerCase().indexOf(_srchText) >= 0) return true;

		// if (this.projectEngineer && this.projectEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.elecDesignEngineer && this.elecDesignEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.mechDesignEngineer && this.mechDesignEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.regionName && this.regionName.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.consultantName && this.consultantName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.specialPoint && this.specialPoint.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.placeOfDelivery && this.placeOfDelivery.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.SOCreationRemarks && this.SOCreationRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.SOReleaseRemarks && this.SOReleaseRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.OrderHandOverRemarks && this.OrderHandOverRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.placeOfDelivery && this.placeOfDelivery.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		// if (this.SOCreationRemarks && this.SOCreationRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;
		const indexSerial = this.serialNo.findIndex(element => {
			if (element.includes(_srchText)) {
			  return true;
			}
		  });
		  if (indexSerial !== -1){
			return true;
		  }



		return false;
	}
	get sso(): SubSalesOrder {
		return this._subSoActObj;
	}
	// public prepareUIData(){

	// }
}
export class UiTblSubSOEqipLevelMF {
	public plantName: string;
	public customerName: string;
	public projectName: string;
	public salesOrderNo: string;
	public subSalesOrderNo: string;
	public rowHeader: string;
	
	public plannedManfMonth: string;
	public invoicingmonth: string;
	public plannedRevenueMonth: string;
	public manfStrategy: string;
	public plndLineLoadingDate: string;
	public reqLineLoadingDate: string;
	public rotddate:string;
	public actLineLoadingDate: string;
	public customerPoValue: string;
	public contractualValue: string;
	public marketingEngineer: string;
	public projectManager: string;
	public projectEngineer: string;
	public elecDesignEngineer: string;
	public mechDesignEngineer: string;
	public salesChannelName: string;
	public regionName: string;
	public poDate: string;
	public clearPODate: string;
	public consultantName: string;
	public warrantyMonths: string;
	public specialPoint: string;
	public specialPointFiles: Array<FileElement> = [];
	public ordertypeName: string;
	public splPriceFileTokens : Array<FileElement> = [];
	public contractDeliveryFirm: string;
	public contractDeliveryWeeks: string;
	public contractDeliveryDate: string;
	public ldApplicability: string;
	public ldPercentage: string;
	public ldCap: string;
	public deliveryTerm: string;
	public placeOfDelivery: string;
	public daysgoodsReach: string;
	public boardname: string;
	public delayreason:string;
	public deliveryFromAbb: string;
	public paymentTerm: string;
	public paymentDays: string;
	public FCMMatCost: string;
	public JSRMatCost: string;
	public FCMGM: string;
	public JSRGM: string;
	public FCMNM: string;
	public JSRNM: string;
	public AdvPmtCondition: string;
	public AdvPmt: string;
	public AdvPmtMilestone: string;
	public PBGPayCondition: string;
	public CPBGPayCondition: string;
	public SOCreationPlanned: string;
	public SOCreationActual: string;
	public SOCreationRemarks: string;
	public SOReleasePlanned: string;
	public SOReleaseActual: string;
	public SOReleaseRemarks: string;
	public OrderHandOverPlanned: string;
	public OrderHandOverActual: string;
	public OrderHandOverRemarks: string;
	public ABGACGSubmissionDetails: string
	public abgOrAcgPlndCollDate : string
	public ABGACGActSubmissDate: string;
	public ABGACGActCollectDate: string;
	public PBGSubmissionDetails: string;
	public pbgReqSubDate: string;
	public pbgPlndSubDate: string
	public PBGActSubmissDate: string;
	public PBGActCollectDate: string;
	public CPBGSubmissionDetails: string;
	public CPBGActSubmissDate: string;
	public CPBGActCollectDate: string;
	public variantOfProduct: string;
	public noOfPanels: string;
	public complexityOfJobs: string;
	public noOfFeedertypes: string;
	public plannedSLDSubmissDate: string;
	public initialSLDSubmissActualDate: string;
	public remarkForSLDSubmission: string;
	public plannedGAFDrawSubmissDate: string;
	public actualGAFDrawSubmissDate: string;
	public remarkForGAFSubmissActualDate: string;

	public plannedSchBOMSubmissDate: string;
	public actualSchBOMSubmisDate: string;
	public remarkSchBOMSubmissDate: string;
	public plannedBusBarSizingCalcSubmissDate: string;
	public actualBusBarSizingCalcSubmissDate: string;
	public remarkBusBarSizingCalcSubmissDate: string;
	public finalDrawingSubmissDate: string;
	public insulationLevelKV: string;
	public typeOfEquipment: string;
	public typeOfBreaker: string;
	public qtyOfPanel: string;
	public qtyOfBreaker: string;
	public breakerPS: string;
	public importedEarthingSwitchApplicability: string;

	public qtyOfVSC: string;
	public kioskApplic: string;
	public tempRiseTestApplic: string;
	public impBrkApplic: string;
	public impVSCApplic: string;
	public spareApplic: string;
	public etApplic: string;
	public geRelayApplic: string;

	public busbarMaterial: string;
	public busbarSleeve: string;
	public cmntOnActualSubmissDate: string;
	public cmntOnActualComplainceDate: string;
	public plannedDrawingAprvlDate: string;
	public actualDrawingAprvlDate: string;
	public remarkDrawingAprvlDate: string;
	public plannedCTFinalEnggToPMDate: string;
	public actualCtFinalEnggToPMDate: string;
	public remarkCtFinalEnggToPMDate: string;

	public plannedCTFinalPMtoSCMDate: string;
	public actualCTFinalPMtoSCMDate: string;
	public remarkCTFinalPMtoSCMDate: string;
	public plannedCTFinalfromSCMDate: string;
	public actualCTFinalfromSCMDate: string;
	public remarkCTFinalfromSCMDate: string;
	public plannedPackingDispatchClrDate: string;
	public actualPackingDispatchClrDate: string;
	public remarkPackingDispatchClrDate: string;
	public plannedSLDApprovalDate: string;
	public actualSLDApprovalDate: string;
	public remarkSLDApprovalDate: string;
	public plannedC40Date: string;
	public actualC40Date: string;
	public remarkC40Date: string;
	public plannedC50Date: string;
	public actualC50Date: string;
	public remarkC50Date: string;
	public plannedC60Date: string;
	public actualC60Date: string;
	public remarkC60Date: string;
	public plannedLongLeadDate: string;
	public actualLongLeadDate: string;
	public remarkLongLeadDate: string;
	public plannedImpBrkrPORlsDate: string;
	public actualImpBrkrPORlsDate: string;
	public remarkImpBrkrPORlsDate: string;

	public plannedImpVscPORlsDate: string;
	public actualImpVscPORlsDate: string;
	public remarkImpVscPORlsDate: string;
	public plannedGERelayPORlsDate: string;
	public actualGERelayPORlsDate: string;
	public remarkGERelayPORlsDate: string;
	public plannedCTPTPORlsDate: string;
	public actualCTPTPORlsDate: string;
	public remarkCTPTPORlsDate: string;
	public plannedRelayPORlsDate: string;
	public actualRelayPORlsDate: string;
	public remarkRelayPORlsDate: string;
	public plannedBreakerPORlsDate: string;
	public actualBreakerPORlsDate: string;
	public remarkBreakerPORlsDate: string;
	public plannedSAPORlsDate: string;
	public actualSAPORlsDate: string;
	public remarkSAPORlsDate: string;
	public plannedMeteringBoxPORlsDate: string;
	public actualMeteringBoxPORlsDate: string;
	public remarkMeteringBoxPORlsDate: string;
	public plannedPickListtoStoresDate: string;
	public requestedPickListtoStoresDate: string;
	public actualPickListtoStoresDate: string;
	public remarkPickListtoStoresDate: string;

	public plannedImpBrkrRcptDate: string;
	public requestedImpBrkrRcptDate: string; 
	public supplierImpBrkrRcptDate: string;
	public actualImpBrkrRcptDate: string;
	public remarkImpBrkrRcptDate: string;
	public plannedImpVSCRcptDate: string;
	public requestedImpVSCRcptDate: string;
	public supplierImpVSCRcptDate: string;
	public actualImpVSCRcptDate: string;
	public remarkImpVSCRcptDate: string;
	public plannedGERelayRcptDate: string;
	public requestedGERelayRcptDate: string;
	public supplierGERelayRcptDate: string;
	public actualGERelayRcptDate: string;
	public remarkGERelayRcptDate: string;
	public plannedCTPTRcptDate: string;
	public requestedCTPTRcptDate: string;
	public supplierCTPTRcptDate: string;
	public actualCTPTRcptDate: string;
	public remarkCTPTRcptDate: string;
	public plannedRelayRcptDate: string;
	public requestedRelayRcptDate: string;
	public supplierRelayRcptDate: string;
	public actualRelayRcptDate: string;
	public remarkRelayRcptDate: string;
	public plannedBreakerRcptDate: string;
	public requestedBreakerRcptDate: string;
	public supplierBreakerRcptDate: string;
	public actualBreakerRcptDate: string;
	public remarkBreakerRcptDate: string;
	public plannedJumperRcptDate: string;
	public requestedJumperRcptDate: string;
	public supplierJumperRcptDate: string;
	public actualJumperRcptDate: string;
	public remarkJumperRcptDate: string;
	public plannedMeterBoxRcptDate: string;
	public requestedMeterBoxRcptDate: string;
	public supplierMeterBoxRcptDate: string;
	public actualMeterBoxRcptDate: string;
	public remarkMeterBoxRcptDate: string;
	public plannedSARcptDate: string;
	public requestedSARcptDate: string;
	public supplierSARcptDate: string;
	public actualSARcptDate: string;
	public remarkSARcptDate: string;
	public plannedBoughtoutFabricationRcptDate: string;
	public requestedBoughtoutFabricationRcptDate: string;
	public supplierBoughtoutFabricationRcptDate: string;
	public actualBoughtoutFabricationRcptDate: string;
	public remarkBoughtoutFabricationRcptDate: string;

	public plannedMatIssuetoLineDate: string;
	public requestedMatIssuetoLineDate: string;
	public actualMatIssuetoLineDate: string;
	public remarkMatIssuetoLineDate: string;
	public plannedLooseMatIssueDate: string;
	public looseMaterialIssueToDispatchRequestDate: string;
	public actualLooseMatIssueDate: string;
	public remarkLooseMatIssueDate: string;
	public plannedMechStickerDate: string;
	public requestedMechStickerDate: string;
	public actualMechStickerDate: string;
	public remarkMechStickerDate: string;
	public plannedMechElecTestDate: string;
	public requestedMechElecTestDate: string;
	public actualMechElecTestDate: string;
	public remarkMechElecTestDate: string;
	public plannedFATDate: string;
	public requestedFATDate: string;
	public actualFATDate: string;
	public remarkFATDate: string;
	public plannedGreenStickerDate: string;
	public requestedGreenStickerDate: string;
	public actualGreenStickerDate: string;
	public remarkGreenStickerDate: string;
	public plannedDispatchDate: string;
	public requestedDispatchDate: string;
	public actualDispatchDate: string;
	public remarkDispatchDate: string;
	public partialDispatchQty: string;
	public actualEarthlingTruckDispatchDate: string;
	public actualSparesDispatchDate: string;


    public totalEquipmentCount:number = 0;
    public totalEquipmentCountForSubSo:number = 0;


	constructor(private _subSoActObj: SubSalesOrder, public _variant:string, private _isFirstRowInSO:boolean, private _isFirstRowInSubOrder:boolean) {

	}

    get isFirstRowInSO():boolean{
        return this._isFirstRowInSO;
    }
    get isFirstRowInSubOrder():boolean{
        return this._isFirstRowInSubOrder;
    }


	searchText(_srchText: string): boolean {
		_srchText = _srchText.toLowerCase();
		if (this.plantName && this.plantName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.customerName && this.customerName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.projectName && this.projectName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesOrderNo && this.salesOrderNo.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.subSalesOrderNo && this.subSalesOrderNo.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.manfStrategy && this.manfStrategy.toLowerCase().indexOf(_srchText) >= 0) return true;
		//if(this.customerPoValue && this.customerPoValue.toLowerCase().indexOf(_srchText) >= 0) return true;
		//if(this.contractualValue && this.contractualValue.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.marketingEngineer && this.marketingEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.projectManager && this.projectManager.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.projectEngineer && this.projectEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.elecDesignEngineer && this.elecDesignEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.mechDesignEngineer && this.mechDesignEngineer.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.regionName && this.regionName.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.consultantName && this.consultantName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.specialPoint && this.specialPoint.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.placeOfDelivery && this.placeOfDelivery.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.SOCreationRemarks && this.SOCreationRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;

		if (this.SOReleaseRemarks && this.SOReleaseRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.OrderHandOverRemarks && this.OrderHandOverRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.placeOfDelivery && this.placeOfDelivery.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.salesChannelName && this.salesChannelName.toLowerCase().indexOf(_srchText) >= 0) return true;
		if (this.SOCreationRemarks && this.SOCreationRemarks.toLowerCase().indexOf(_srchText) >= 0) return true;



		return false;
	}
	get sso(): SubSalesOrder {
		return this._subSoActObj;
	}
	// public prepareUIData(){

	// }
}